import { isNil } from 'lodash';
import { ValidFileFormat } from 'constants/files';
import docIcon from 'assets/images/doc.png';
import pdfIcon from 'assets/images/pdf.png';
import imageIcon from 'assets/images/image.png';
import xlsIcon from 'assets/images/xls.png';
import textIcon from 'assets/images/text.png';

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export function getFileIcon(fileName: string) {
  const fileType = fileName.split('.').pop() as ValidFileFormat;
  switch (fileType) {
    case 'pdf':
      return pdfIcon;

    case 'csv':
    case 'xlsx':
      return xlsIcon;

    case 'doc':
    case 'docx':
    case 'msg':
      return docIcon;

    case 'png':
    case 'jpg':
    case 'jpeg':
      return imageIcon;

    default:
      return textIcon;
  }
}

export const abbreviateNumber = (value: string): string => {
  const num = parseFloat(value.replace(/[^0-9.-]+/g, ''));

  if (isNaN(num)) {
    return value;
  }

  if (num >= 1000000) {
    const formatted = formatDecimal(num / 1000000);
    return formatted.slice(0, -1).replace(/\.0$/, '') + 'M';
  }

  if (num >= 1000) {
    const formatted = formatDecimal(num / 1000);
    return formatted.slice(0, -1).replace(/\.0$/, '') + 'K';
  }

  return formatDecimal(num);
};

const formatDecimal = (value: number | string): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(num)) {
    return typeof value === 'string' ? value : '';
  }

  return num.toFixed(2);
};

export const stringReplaceAll = (
  str: string,
  search: string,
  replace: string
) => str.split(search).join(replace);

export const formatLocaleNumber = (value?: number) => {
  if (isNil(value)) return '';
  const parts = value.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const formatReceiptNumber = (value: number) => {
  const RECEIPT_NUMBER_PREFIX = 'RCP';

  return RECEIPT_NUMBER_PREFIX + '-' + value.toString().padStart(5, '0');
};
